import { useCallback, useEffect, useState } from "react";
import { isWeb } from "@companion-core/shared/app/Utils/platform";
import { useHeaderStore } from "@companion-core/shared/app/Store/header";
import { useStatusBarStore } from "@companion-core/shared/app/Store/statusBar";

export const useTransparentHeader = () => {
  const [scrollTop, setScrollTop] = useState(0);
  const { transparentHeader, setTransparentHeader, setIsOnATransparentHeaderPage } = useHeaderStore(
    (state) => ({
      transparentHeader: state.transparentHeader,
      setTransparentHeader: state.setTransparentHeader,
      setIsOnATransparentHeaderPage: state.setIsOnATransparentHeaderPage,
    }),
  );
  const { setBarStyle } = useStatusBarStore((state) => ({
    setBarStyle: state.setBarStyle,
  }));

  const updateTransparentHeader = (value: boolean) => {
    setBarStyle(value ? "light-content" : "dark-content");
    setTransparentHeader(value);
  };

  const handleScroll = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: any) => {
      const yOffset = isWeb()
        ? document.documentElement.scrollTop
        : event.nativeEvent.contentOffset.y;
      if (yOffset === 0) setScrollTop(yOffset);
      if (transparentHeader && yOffset > 0) {
        updateTransparentHeader(false);
      } else if (!transparentHeader && yOffset <= 0) {
        updateTransparentHeader(true);
      }
    },
    [scrollTop, transparentHeader],
  );

  useEffect(() => {
    setIsOnATransparentHeaderPage(true);
    if (isWeb()) {
      const { scrollTop: yOffset } = document.documentElement;
      if (yOffset === 0) updateTransparentHeader(true);

      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
        updateTransparentHeader(false);
        setIsOnATransparentHeaderPage(false);
      };
    } else {
      if (scrollTop === 0) updateTransparentHeader(true);
      return () => {
        updateTransparentHeader(false);
        setIsOnATransparentHeaderPage(false);
      };
    }
  }, [isWeb() && transparentHeader]);

  return { handleScroll };
};
